/**
 * Read More/ Read Less
 * -------------------------------------------------------
 * Used to for read more/ read less on the global-media-text-full-width snippet.
 * -------------------------------------------------------
 */

 import {
     registerLegacySalvoLiteComponent,
     legacySalvoLiteLog as log
 } from '@eastsideco/salvo-ts';
 
 class ReadMore {
     constructor (theme, elem) {
         this._theme = theme
         this._elem = elem
     }
     onInit () {
         const controlBtns = this._elem.querySelectorAll('.excerpt-control') 

         if (controlBtns.length === 0) return

         controlBtns.forEach(btn => {
            btn.addEventListener('click', (e) => {
                const copyItems = this._elem.querySelectorAll('.copy')
                if (copyItems.length === 0) return
                copyItems.forEach(copy => {
                    copy.classList.toggle('hide')
                }) 
            })
         })
     }
 }
 
 export default registerLegacySalvoLiteComponent({
     component: ReadMore,
     selector: '[data-read-more]', // Required
 });
 